(function () {
  'use strict';

  Controller.$inject = ['SensorService', '$rootScope', '$state', 'AppUtils', '$element', '$timeout', '$window', '$translate'];

  window.angular.module('app').component('externalDataDisplay', {
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      sensor: '<',
      assetName: '<',
      data: '<',
      onlyContent: '<',
      options: '<',
      disableClick: '<',
      onLoadContent: '=',
      maxHeight: '<',
      disableSpinner: '<',
      filterByZone: '<',
    },
    template:'<div class="panel panel-default rt-panel rt-panel-sm external-data-panel" ng-if="!ctrl.onlyContent"><header class="panel-heading"><h2 class="nowrap"><strong>{{ctrl.sensor.name}}</strong> <small>{{ctrl.assetName}}</small></h2><div class="panel-toolbars pull-right" ng-if="ctrl.content"><div class="panel-toolbar"><div class="btn-group" data-toggle="buttons"><label ng-if="ctrl.hasImages" ng-click="ctrl.setViewMode(\'image\')" ng-class="{active: ctrl.viewMode === \'image\'}" class="btn btn-default btn-xs" translate-attr="::{title: \'entities._all.image\'}"><input type="radio"> <i class="fas fa-fw fa-image"></i></label> <label ng-if="ctrl.hasVideo" ng-click="ctrl.setViewMode(\'video\')" ng-class="{active: ctrl.viewMode === \'video\'}" class="btn btn-default btn-xs" title="Video"><input type="radio"> <i class="fas fa-fw fa-video"></i></label> <label ng-if="ctrl.hasMeta" ng-click="ctrl.setViewMode(\'info\')" ng-class="{active: ctrl.viewMode === \'info\'}" class="btn btn-default btn-xs" translate-attr="::{title: \'entities.sensortype.__types.ExternalData\'}"><input type="radio"> <i class="fas fa-fw fa-info-circle"></i></label> <label ng-click="ctrl.setViewMode(\'raw\')" ng-class="{active: ctrl.viewMode === \'raw\'}" class="btn btn-default btn-xs" translate-attr="::{title: \'general.details\'}"><input type="radio"> <i class="fas fa-fw fa-code"></i></label></div></div></div></header><div class="panel-body" ng-class="{\'with-location\': ctrl.data.location}"><div class="rt-content"><div ng-if="ctrl.content" class="external-data-display" ng-class="{ \'external-data-display--with-image\': ctrl.viewMode === \'image\', \'external-data-display--with-video\': ctrl.viewMode === \'video\', \'external-data-display--info\': ctrl.viewMode === \'info\' }"><div ng-if="ctrl.viewMode === \'image\'" class="external-data-display__image-mode"><div class="external-data-display__media" ng-style="ctrl.imageMediaStyle"><a class="external-data-display__media-link" ng-class="{\'cursor-pointer\': !ctrl.disableClick}" ng-click="ctrl.expand()" target="_blank"><image-sequence ng-if="ctrl.imagesSrc.length" images-src="ctrl.imagesSrc" max-height="ctrl.imageMaxHeight || ctrl.maxHeight" on-load-content="ctrl.onLoadImage" dimensions="ctrl.dimensions" sensor="ctrl.sensor" data="ctrl.data" field="\'image\'"></image-sequence></a></div><div class="alert alert-info external-data-summary" ng-if="ctrl.hasMeta" role="status"><div class="external-data-summary__header" ng-if="ctrl.source"><div class="external-data-summary__badge"><i class="fas fa-plug"></i> <span>{{ctrl.source}}</span></div></div><div class="external-data-summary__title" ng-if="ctrl.infoTitle">{{ctrl.infoTitle}}</div><div class="external-data-summary__title" ng-if="!ctrl.infoTitle" translate="{{ctrl.infoTitleKey}}"></div><div class="external-data-summary__message" ng-if="ctrl.infoMessage">{{ctrl.infoMessage}}</div><div class="external-data-summary__meta" ng-if="ctrl.metaEntries.length"><div class="external-data-summary__meta-item" ng-repeat="entry in ctrl.metaEntries"><span class="external-data-summary__meta-key">{{entry.key}}</span> <span>{{entry.value}}</span></div></div></div></div><div ng-if="ctrl.viewMode === \'video\'" class="external-data-display__video-mode"><video-renderer ng-if="ctrl.videoSrc" video-src="ctrl.videoSrc" on-load="ctrl.onLoadVideo"></video-renderer><div class="alert alert-info external-data-summary" ng-if="ctrl.hasMeta" role="status"><div class="external-data-summary__header" ng-if="ctrl.source"><div class="external-data-summary__badge"><i class="fas fa-plug"></i> <span>{{ctrl.source}}</span></div></div><div class="external-data-summary__title" ng-if="ctrl.infoTitle">{{ctrl.infoTitle}}</div><div class="external-data-summary__title" ng-if="!ctrl.infoTitle" translate="{{ctrl.infoTitleKey}}"></div><div class="external-data-summary__message" ng-if="ctrl.infoMessage">{{ctrl.infoMessage}}</div><div class="external-data-summary__meta" ng-if="ctrl.metaEntries.length"><div class="external-data-summary__meta-item" ng-repeat="entry in ctrl.metaEntries"><span class="external-data-summary__meta-key">{{entry.key}}</span> <span>{{entry.value}}</span></div></div></div></div><div ng-if="ctrl.viewMode === \'info\'" class="external-data-info" role="status"><div class="external-data-info__icon" aria-hidden="true"><i class="fas fa-wifi"></i></div><div class="external-data-info__badge" ng-if="ctrl.source">{{ctrl.meta.referenceId}}</div><div class="external-data-info__title" ng-if="ctrl.infoTitle">{{ctrl.infoTitle}}</div><div class="external-data-info__title" ng-if="!ctrl.infoTitle" translate="{{ctrl.infoTitleKey}}"></div><div class="external-data-info__message" ng-if="ctrl.infoMessage">{{ctrl.infoMessage}}</div><div class="external-data-info__meta" ng-if="ctrl.metaEntries.length"><div class="external-data-info__meta-item" ng-repeat="entry in ctrl.metaEntries"><span class="external-data-info__meta-key">{{entry.key}}</span> <span>{{entry.value}}</span></div></div></div><pre ng-if="ctrl.viewMode === \'raw\'">{{ctrl.content | json}}</pre></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div><div class="rt-footer"><div class="date" ng-if="ctrl.content">{{ctrl.data.from | date: "yyyy-MM-dd HH:mm:ss"}}<div ng-if="ctrl.data.location"><a target="_blank" ng-href="https://www.google.com/maps/search/?api=1&query={{ctrl.data.location.coordinates[1]}},{{ctrl.data.location.coordinates[0]}}">[ {{ctrl.data.location.coordinates[1]}}, {{ctrl.data.location.coordinates[0]}} ]</a></div></div><div class="rt-footer chart-footer" ng-if="ctrl.data && !ctrl.data.content"><div class="small" translate>errors.NOT_DATA_FOUND</div></div><div class="rt-footer chart-footer" ng-if="!ctrl.data"><div class="small"><i translate>general.loading</i><i>...</i></div></div></div></div></div><div ng-if="ctrl.onlyContent" class="rt-content external-data-only-content"><div ng-if="ctrl.content" class="external-data-display" ng-class="{ \'external-data-display--with-image\': ctrl.viewMode === \'image\', \'external-data-display--with-video\': ctrl.viewMode === \'video\', \'external-data-display--info\': ctrl.viewMode === \'info\' }"><div ng-if="ctrl.viewMode === \'image\'" class="external-data-display__image-mode external-data-display__image-mode--overlay"><div class="external-data-display__media" ng-style="ctrl.imageMediaStyle"><a class="external-data-display__media-link" ng-class="{\'cursor-pointer\': !ctrl.disableClick}" ng-click="ctrl.expand()" target="_blank"><image-sequence ng-if="ctrl.imagesSrc.length" images-src="ctrl.imagesSrc" max-height="ctrl.imageMaxHeight || ctrl.maxHeight" on-load-content="ctrl.onLoadImage" dimensions="ctrl.dimensions" sensor="ctrl.sensor" data="ctrl.data" field="\'image\'"></image-sequence><div class="alert alert-info external-data-summary external-data-summary--overlay" ng-if="ctrl.hasMeta" role="status"><div class="external-data-summary__header" ng-if="ctrl.source"><div class="external-data-summary__badge"><i class="fas fa-plug"></i> <span>{{ctrl.source}}</span></div></div><div class="external-data-summary__title" ng-if="ctrl.infoTitle">{{ctrl.infoTitle}}</div><div class="external-data-summary__title" ng-if="!ctrl.infoTitle" translate="{{ctrl.infoTitleKey}}"></div><div class="external-data-summary__message" ng-if="ctrl.infoMessage">{{ctrl.infoMessage}}</div><div class="external-data-summary__meta" ng-if="ctrl.metaEntries.length"><div class="external-data-summary__meta-item" ng-repeat="entry in ctrl.metaEntries"><span class="external-data-summary__meta-key">{{entry.key}}</span> <span>{{entry.value}}</span></div></div></div></a></div></div><div ng-if="ctrl.viewMode === \'video\'" class="external-data-display__video-mode"><video-renderer ng-if="ctrl.videoSrc" video-src="ctrl.videoSrc" on-load="ctrl.onLoadVideo"></video-renderer></div><div ng-if="ctrl.viewMode === \'info\'" class="external-data-info" role="status"><div class="external-data-info__signal" aria-hidden="true"><div class="external-data-info__signal-ring"><div class="external-data-info__signal-core"><div class="external-data-info__icon" aria-hidden="true" style="font-size: 48px; margin-bottom: 10px;"><i class="fas fa-wifi"></i></div></div></div></div><div cla <div class="external-data-info__badge" ng-if="ctrl.source">{{ctrl.meta.referenceId}}</div><div class="external-data-info__title" ng-if="ctrl.infoTitle">{{ctrl.infoTitle}}</div><div class="external-data-info__title" ng-if="!ctrl.infoTitle" translate="{{ctrl.infoTitleKey}}"></div><div class="external-data-info__message" ng-if="ctrl.infoMessage">{{ctrl.infoMessage}}</div><div class="external-data-info__meta" ng-if="ctrl.metaEntries.length"><div class="external-data-info__meta-item" ng-repeat="entry in ctrl.metaEntries"><span class="external-data-info__meta-key">{{entry.key}}</span> <span>{{entry.value}}</span></div></div></div><pre ng-if="ctrl.viewMode === \'raw\'">{{ctrl.content | json}}</pre></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div>',
  });

  function Controller(SensorService, $root, $state, utils, $element, $timeout, $window, $translate) {
    const angular = window.angular;
    const reservedMetaKeys = {
      title: true,
      name: true,
      text: true,
      description: true,
      message: true,
    };

    let vm = this;
    
    vm.viewMode = 'raw';
    vm.imagesSrc = [];
    vm.hasImages = false;
    vm.hasVideo = false;
    vm.hasMeta = false;
    vm.imageMediaStyle = {};
    vm.setViewMode = setViewMode;
    vm.$onInit = function () {

      angular.element($window).on('resize', scheduleImageLayoutUpdate);
      vm.meta = vm.data?.content?.meta
      vm.state = $state.get().reduce((filtered, current) => {
        const name = current.name;
        const component = current.component;
        if (name.includes('dataDisplay') && component === 'monitoringDataDisplay') {
          filtered.push(current);
        }
        return filtered;
      }, [])[0];

      vm.dimensions = {};
      vm.onLoadImage = onLoadImage;
      vm.onLoadVideo = onLoadVideo;
      vm.expand = expand;
      updateDisplayData();
    };

    vm.$onDestroy = function () {
      angular.element($window).off('resize', scheduleImageLayoutUpdate);
      if (vm.imageLayoutPromise) {
        $timeout.cancel(vm.imageLayoutPromise);
      }
    };

    vm.$onChanges = function () {
      vm.disableSpinner = typeof vm.disableSpinner === 'boolean' ? vm.disableSpinner : false;
      updateDisplayData();
    };

    function getImages() {
      if (vm.content) {
        vm.images = vm.content.files ? vm.content.files.image : null;
        if (vm.images) {
          utils.sortArrayByField(vm.images, 'originalFilename');
        }
      } else {
        vm.images = null;
      }
    }

    function getVideo() {
      const video = vm.content?.files?.video?.[0];
      vm.video = video || null;
      vm.videoSrc = video ? SensorService.getFileUrl(vm.sensor.id, video) : null;
    }

    function onLoadImage(err, images) {
      if (vm.onLoadContent) {
        vm.onLoadContent(err, images);
      }

      if (!err) {
        scheduleImageLayoutUpdate();
      }
    }

    function onLoadVideo(err, video) {
      if (err && !vm.hasImages) {
        vm.viewMode = vm.hasMeta ? 'info' : 'raw';
      }

      vm.loadedVideo = video;
      if (vm.onLoadContent) {
        vm.onLoadContent(err, video);
      }
    }

    function updateDisplayData() {
      vm.content = vm.data?.content;
      vm.meta = vm.data?.content?.meta
      vm.imagesSrc = [];
      vm.videoSrc = null;
      vm.source = '';
      vm.infoTitle = '';
      vm.infoMessage = '';
      vm.metaEntries = [];
      vm.hasImages = false;
      vm.hasVideo = false;
      vm.hasMeta = false;

      if (!vm.data || !vm.content) {
        return;
      }

      getImages();
      getVideo();

      vm.hasImages = Array.isArray(vm.images) && vm.images.length > 0;
      vm.hasVideo = !!vm.videoSrc;
      vm.imagesSrc = vm.hasImages
        ? vm.images.map((image) => SensorService.getImageUrl(vm.sensor.id, image))
        : [];

      vm.source = vm.content.source || '';
      if (!vm.meta) {
        return;
      }
      vm.infoTitle = vm.meta.type || '';
      vm.infoTitleKey = vm.meta.text || vm.meta.description || vm.meta.message || '';
      vm.metaEntries = [];
      if (vm.meta?.duration) {
        vm.metaEntries.push({
          key: $translate.instant('entities.sensortype.externalData.duration'),
          value: formatDuration(secondsToDuration(vm.meta.duration)),
        });
      }
      vm.hasMeta = !!(vm.source || vm.infoTitle || vm.infoMessage || vm.metaEntries.length);

      if (!vm.hasImages && !vm.hasVideo) {
        onLoadImage(null, []);
      }

      vm.viewMode = vm.hasImages ? 'image' : vm.hasVideo ? 'video' : vm.hasMeta ? 'info' : 'raw';
      scheduleImageLayoutUpdate();
    }

    function formatMetaValue(value) {
      if (value === null || value === undefined) {
        return '';
      }

      if (typeof value === 'object') {
        return JSON.stringify(value);
      }

      return String(value);
    }

    function expand() {
      if (vm.disableClick) {
        return;
      }

      const dataId = vm.data.referenceId || vm.data.id;
      window.open(
        $state.href(
          vm.state,
          {
            projectId: $root.projectId,
            assetId: vm.sensor.assetId,
            sensorId: vm.sensor.id,
            dataId: utils.isDate(dataId) ? dataId.getTime() : dataId,
            zoneFilter: true,
          },
          '_blank'
        )
      );
    }

    function setViewMode(mode) {
      vm.viewMode = mode;
      scheduleImageLayoutUpdate();
    }

    function scheduleImageLayoutUpdate() {
      if (vm.imageLayoutPromise) {
        $timeout.cancel(vm.imageLayoutPromise);
      }

      vm.imageLayoutPromise = $timeout(updateImageLayout, 0);
    }

    function updateImageLayout() {
      if (!vm.hasImages || vm.viewMode !== 'image') {
        vm.imageMaxHeight = null;
        vm.imageMediaStyle = {};
        return;
      }

      const host = $element[0];
      const viewport = host.querySelector('.rt-content');
      const imageMode = host.querySelector('.external-data-display__image-mode');

      if (!viewport || !imageMode) {
        return;
      }

      const availableWidth = imageMode.clientWidth;
      let availableHeight = vm.onlyContent ? getAvailableHeight(host, viewport) : viewport.clientHeight;

      if (!vm.onlyContent) {
        const summary = host.querySelector('.external-data-summary');
        if (summary) {
          availableHeight -= summary.offsetHeight + 8;
        }
      }

      if (availableWidth <= 0 || availableHeight <= 0) {
        vm.imageMaxHeight = null;
        vm.imageMediaStyle = {};
        return;
      }

      const targetRatio = 16 / 9;
      let imageFrameWidth = Math.floor(availableWidth);
      let imageFrameHeight = Math.floor(imageFrameWidth / targetRatio);

      if (imageFrameHeight > availableHeight) {
        imageFrameHeight = Math.floor(availableHeight);
        imageFrameWidth = Math.floor(imageFrameHeight * targetRatio);
      }

      vm.imageMaxHeight = imageFrameHeight;
      vm.imageMediaStyle = {
        width: `${imageFrameWidth}px`,
        height: `${imageFrameHeight}px`,
        maxWidth: '100%',
      };
    }

    function getAvailableHeight(host, viewport) {
      const candidates = [viewport, host];
      let current = host.parentElement;

      while (current && candidates.length < 8) {
        candidates.push(current);
        current = current.parentElement;
      }

      for (const element of candidates) {
        if (!element || !element.getBoundingClientRect) {
          continue;
        }

        const rect = element.getBoundingClientRect();
        if (rect.height > 120) {
          return rect.height;
        }
      }

      return Math.floor($window.innerHeight * 0.6);
    }
    function secondsToDuration(totalSeconds) {
      const safe = Math.max(0, Math.floor(Number(totalSeconds) || 0));
      const days = Math.floor(safe / 86400);
      const hours = Math.floor((safe % 86400) / 3600);
      const minutes = Math.floor((safe % 3600) / 60);
      const seconds = safe % 60;
      return {
        days: String(days),
        hours: String(hours),
        minutes: String(minutes),
        seconds: String(seconds),
      };
    }
    function formatDuration(duration) {
      const units = ['days', 'hours', 'minutes', 'seconds'];
    
      return units
        .filter(unit => Number(duration[unit]) > 0)
        .map(unit => {
          const value = Number(duration[unit]);
          const translatedUnit = $translate.instant(`entities.sensortype.externalData.units.${unit}`);
    
          return `${value} ${translatedUnit}`;
        })
        .join(', ');
    }
  }

})();
